import {DestinationWarehouse} from "./DestinationWarehouse";

export class SupplyDTO {
    id: number;
    departureDate: Date;
    acceptanceDate: Date;
    title: string;
    warehouses: DestinationWarehouse[];
    isOzon: boolean;


    constructor(id: number, departureDate: Date, acceptanceDate: Date, title: string, warehouses: DestinationWarehouse[], isOzon: boolean) {
        this.id = id;
        this.departureDate = departureDate;
        this.acceptanceDate = acceptanceDate;
        this.title = title;
        this.warehouses = warehouses;
        this.isOzon = isOzon;
    }
}